export class weightageRolewiseModel {
    RoleListAPI: any;
    weightageRolewiseListAPI: any;
    weightageRolewiseIDAPI: string;
    weightageRolewiseUpdateAPI: any;


}
